class NavButton {

    constructor(){
        if (this.actionIsNeeded) {
            this.init();
        }
    }

    /**
     * Check if the component is used
     */
    actionIsNeeded() {
        return document.querySelector('.js-nav-button').length
        // return true;
    }

    /**
     * Init the component
     * Interaction, events, etc.
     */
    init() {

        // console.log("init nav script");

        let navButton = document.querySelector('.js-nav-button'),
            navLinks = document.querySelectorAll('.nav-link')/*,
            navOverlay = document.querySelector('.js-nav-overlay')*/
        /*
        const navigationMenu = document.querySelector('.navigation-menu')
        const navLinks = document.querySelectorAll('.nav-link')
        */

        let toggleNavClasses = () => {
            // document.body.classList.toggle('has-navi-open')
            navButton.classList.toggle('is-active')
            navButton.blur()
        }
        let removeNavClasses = () => {
            //document.body.classList.remove('has-navi-open')
            navButton.classList.remove('is-active')
            navButton.blur()
        }

        if (navButton) {
            navButton.addEventListener("click", (e) => {
                toggleNavClasses()
            });
            /*navOverlay.addEventListener("click", (e) => {
                navButton.classList.toggle("is-active");
                document.body.classList.toggle("has-navi-open");
            });*/
        }

        /*if (navLinks) {
            navLinks.forEach(link => {
                    link.addEventListener('click', function handleClick(event) {
                        removeNavClasses()
                    });
                }
            )
        }*/
    }
}

export default NavButton;
